import { useOuraData } from "../contexts/OuraDataContext";

/**
 * WHAT:
 *   Optimized Heart Rate Hook using centralized data context.
 *
 * WHY:
 *   Uses centralized data context instead of making separate API calls.
 *
 * @returns Object containing heart rate data, error, and loading state
 *
 */
export const useOptimizedHeartRate = () => {
  const { error, heartrate, loading } = useOuraData();

  return {
    error,
    heartrate,
    loading,
  };
};
